import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursorAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cursor-ai, agent, magic"} maskId="square-filled-radius-0-stroke-1-IconCursorAi"><path d="M13.4 2H12.6L11.6 4.6L9 5.6V6.4L11.6 7.4L12.6 10H13.4L14.4 7.4L17 6.4V5.6L14.4 4.6L13.4 2Z" fill="currentColor"/><path d="M8.08984 4.87793L8 4.91309V7.08691L10.8262 8.17285L11.9131 11H14.0869L15.1729 8.17285L15.8711 7.9043L22.2939 10.4023L14.4023 14.4219L9.89453 22.1768L2.89453 2.85742L8.08984 4.87793Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCursorAi;
